import {
  type ContainerProps,
  Container as MantineContainer,
  type MantineStyleProps,
} from "@mantine/core";

type Props = {
  children: React.ReactNode;
} & Omit<ContainerProps, "children"> &
  MantineStyleProps;

export function Container(props: Props) {
  const { children, ...cotainerProps } = props;
  const defaultOption: Omit<ContainerProps, "children"> = {};
  const option = Object.assign({}, defaultOption, cotainerProps);
  return <MantineContainer {...option}>{children}</MantineContainer>;
}
